import { render, staticRenderFns } from "./RightSideColumn.vue?vue&type=template&id=19a5d02c&scoped=true&"
import script from "./RightSideColumn.vue?vue&type=script&lang=js&"
export * from "./RightSideColumn.vue?vue&type=script&lang=js&"
import style0 from "./RightSideColumn.vue?vue&type=style&index=0&id=19a5d02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5d02c",
  null
  
)

export default component.exports